import $ from 'jquery';

const mobileMenuBreakpoint = 1200;
const $win = $(window);
const $body = $('body');

const $header = $('.site-header-wrap');
const $headerMenu = $('.site-header .site-header__menu');
const $headerNav = $('.site-header .site-header__nav');
const $menuItems = $('#menu-menu-1 > .menu-item-has-children')
const $header_links = $('#menu-menu-1 > .menu-item-has-children > a')
let $previousItem = $()

function NavigateMobileSubMenu(level, $subMenu) {
    $subMenu = $subMenu || null;
    if($subMenu) {
        $headerMenu.find('.sub-menu[data-depth=' + level + ']').removeClass('active');
        $subMenu.addClass('active');
    }
    $headerMenu.css('transform', 'translate(' + (-100 * level) + '%)');
    $headerNav.attr('data-currentlevel', level);
}

$('.site-header .sub-menu-back').click(function () {
    const level = $(this).attr('data-backlevel');
    NavigateMobileSubMenu(level);
});

$('.site-header .menu-item-has-children').each(function (){
    const $self = $(this);
    const $link = $self.find('> a');
    const $subMenu = $self.find('> .sub-menu');
    const $subMenuBack = $subMenu.find('> .sub-menu__back');

    const linkHref = $link.attr('href');

    if(linkHref !== '#' && linkHref !== '' && linkHref !== undefined) {
        const $menuItemDuplicate = $('<li class="menu-item menu-item--duplicate"></li>');
        $link.clone().appendTo($menuItemDuplicate);
        $subMenuBack.after($menuItemDuplicate);
    }

    $link.click(function (event) {
        if($win.width() <= mobileMenuBreakpoint) {
            event.preventDefault();
            NavigateMobileSubMenu($subMenu.attr('data-depth'), $subMenu);
        }
    });
});

$('.mobile-close, .mobile-menu-toggle').click(function () {
    $headerNav.toggleClass('open');
    $(this).toggleClass('is-active');
});

// Add header height as css var.
function setMenuHeightVar() {
    $body.css('--header-height', $header.height() + 'px');
}

// Do this on page load
setMenuHeightVar();

// Do this on resize
window.addEventListener('resize', event => {
    setMenuHeightVar();
});

$(window).on('load', ()=> {
    $menuItems.on('click', function(event) {
        if($(window).outerWidth() > 1200) {
            const $this = $(event.currentTarget)
            if($this.find('.menu-title').length === 0 ) {
                const $menuItemsText = $this.find('>a').text()
                $this.find('.list-item-container').before('<a href="' + $this.find('> a').attr('href') + '" class="menu-title">' + $menuItemsText + '</a>')
            }
            if($(event.target).is($menuItems) || $(event.target).is('#menu-menu-1 > li > a')) {
                if ($(this).hasClass('menu-item-transition') !== $previousItem.hasClass('menu-item-transition')) {
                    $previousItem.removeClass('menu-item-transition')
                }
                $previousItem = $(this);
                $(this).toggleClass('menu-item-transition')
            }
            if($(this).hasClass('menu-item-transition')) {
                $header.addClass('darker-blur');
            } else {
                $header.removeClass('darker-blur');
            }
        } else {
            const $subMenu = $(this).find('> .sub-menu');
            const $subMenuBack = $subMenu.find('.level-1-content > .sub-menu__back');
            const $titleText = $(this).find(">a").text()
            const $menuTitle = $('<h2 class="menu-title">' + $titleText + '</h2>');
            if ($(event.target).is($menuItems) || $(event.target).is('#menu-menu-1 > li > a') || $(event.target).closest($subMenuBack).length) {
                $('.inside-close').toggleClass('blue-close')
            }
            if (!$(this).find('.level-1 .menu-title').length) {
                $subMenuBack.after($menuTitle);
            }
        }
    })
})

$header_links.on('click', function(event) {
    event.preventDefault()
})
